/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    arrayOf, string,
    func, shape,
} from 'prop-types';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { ExpandMore } from '@material-ui/icons';

const DesktopOccasionDropdown = (props) => {
    const { holidays, selected, onChange } = props;
    const defaultSelectValue = holidays[0].id;
    return (
        <Select
            value={selected || defaultSelectValue}
            className="occasionDropdown"
            onChange={onChange}
            inputProps={{
                classes: {
                    select: 'select-class',
                    root: 'select-root',
                    icon: 'select-icon',
                },
            }}
            IconComponent={ExpandMore}
        >
            {holidays.map((d) => (
                <MenuItem key={d.id} value={d.id}>
                    {d.name}
                </MenuItem>
            ))}
        </Select>
    );
};

DesktopOccasionDropdown.propTypes = {
    holidays: arrayOf(
        shape({
            id: string,
            name: string,
        }),
    ).isRequired,
    onChange: func.isRequired,
    selected: string.isRequired,
};

export default DesktopOccasionDropdown;
